import styled from "styled-components"



export const ModalHeader = styled.div`
  color: white;
  background: rgba(0,0,0,.2);
  font-size: 1rem;
  font-weight: 300;
  padding: 1rem;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: .04rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%,0);
  top: 0;
  z-index: 1;

  svg {
    font-size: 1rem;
  }
`

export const IconLeftWrapper = styled.div`
  position: absolute;
  z-index: 1;
  left: 1.5rem;
  top: 50%;
  transform: translate(0,-50%);
  color: white;
  font-size: 4rem;
` 

export const IconRightWrapper = styled.div`
  position: absolute;
  z-index: 1;
  right: 1.5rem;

  transform: translate(0,-50%);
  top: 50%;
  color: white;
  font-size: 4rem;
`

export const ModalTitle = styled.div`
  position: relative;


  &:before {
    content:"";
    height: .2rem;
    background-color: ${props => props.color || props.theme.colors.primary};
    position: absolute;
    bottom: -0.25rem;
    left: 50%;
    transform: translate(-50%,0);
    width: 8rem;
  }

`
export const ReactPlayerWrapper = styled.div`
  position: relative;
`


